import { createContext, memo, ReactNode, useContext, useMemo, useState } from "react";
import { useTablePropsContext } from "../../context";
import { RowViewType } from "../../types";

type SettingsContextProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  advancedFilters: boolean;
  setAdvancedFilters: (advancedFilters: boolean) => void;
  rowView: RowViewType,
  setRowView: (rowView: RowViewType) => void,
}

const SettingsContext = createContext<SettingsContextProps>({
  isOpen: false,
  setIsOpen: isOpen => {},
  advancedFilters: false,
  setAdvancedFilters: isOpen => {},
  rowView: "regular",
  setRowView: rowView => {},
});

export const SettingsContextProvider = memo<{ children: ReactNode | ReactNode[] }>(({ children }) => {
  const tableProps = useTablePropsContext();
  const [ isOpen, setIsOpen ] = useState(false);
  const [ advancedFilters, setAdvancedFilters ] = useState(tableProps?.defaultUseAdvancedFilters || false);
  const [ rowView, setRowView ] = useState(tableProps?.defaultRowView!);
  return (
    <SettingsContext.Provider
      value={useMemo(() => ({
        isOpen,
        setIsOpen,
        advancedFilters,
        setAdvancedFilters,
        rowView,
        setRowView,
      }), [ isOpen, advancedFilters, rowView, setRowView ])}
    >
      {children}
    </SettingsContext.Provider>
  );
});

export const useSettingsContext = () => useContext(SettingsContext);
